// extracted by mini-css-extract-plugin
export default {"wrapper":"qXFRCt71kNBZYHZ2Wk5e"};